import React from "react";

import {
    FiChevronLeft,
    FiChevronRight,
} from "react-icons/fi";

import "./EmployeeCommon.css";


const EmployeePagination = ({
    page = 1,

    limit = 10,

    totalRecords = 0,

    totalPages = 1,

    onPageChange,

    onLimitChange,
}) => {

    const safePage =
        Math.max(
            Number(page) ||
            1,
            1
        );


    const safeLimit =
        Math.max(
            Number(limit) ||
            10,
            1
        );


    const safeTotal =
        Math.max(
            Number(totalRecords) ||
            0,
            0
        );


    const safeTotalPages =
        Math.max(
            Number(totalPages) ||
            1,
            1
        );


    const start =
        safeTotal ===
        0
            ? 0
            : (
                (
                    safePage -
                    1
                ) *
                safeLimit
            ) +
            1;


    const end =
        Math.min(
            safePage *
            safeLimit,
            safeTotal
        );


    return (

        <div className="employee-common-pagination">

            <span>

                Showing

                {" "}

                <strong>
                    {start}
                </strong>

                {" - "}

                <strong>
                    {end}
                </strong>

                {" of "}

                <strong>
                    {safeTotal}
                </strong>

            </span>


            <div>

                <select
                    value={
                        safeLimit
                    }
                    onChange={
                        (
                            event
                        ) =>
                            onLimitChange?.(
                                Number(
                                    event
                                        .target
                                        .value
                                )
                            )
                    }
                >

                    <option value="10">
                        10 / page
                    </option>

                    <option value="20">
                        20 / page
                    </option>

                    <option value="50">
                        50 / page
                    </option>

                    <option value="100">
                        100 / page
                    </option>

                </select>


                <button
                    type="button"
                    onClick={
                        () =>
                            onPageChange?.(
                                safePage -
                                1
                            )
                    }
                    disabled={
                        safePage <=
                        1
                    }
                >

                    <FiChevronLeft />

                </button>


                <span>
                    Page {safePage} of {safeTotalPages}
                </span>


                <button
                    type="button"
                    onClick={
                        () =>
                            onPageChange?.(
                                safePage +
                                1
                            )
                    }
                    disabled={
                        safePage >=
                        safeTotalPages
                    }
                >

                    <FiChevronRight />

                </button>

            </div>

        </div>

    );

};


export default EmployeePagination;